import { useQueryClient, useQuery } from '@tanstack/react-query'

import { API_RESOURCE } from '@/constants/api.constant'
import useAction from '@/hooks/useAction'
import { useCrud } from '@/hooks/useCrud'
import OfferCostBudgetService from './offerCostBudget.service'

export const useOfferCostBudget = () => {
  const service = new OfferCostBudgetService()
  const baseCrud = useCrud(API_RESOURCE.OFFER_COST_BUDGET, service)
  const queryClient = useQueryClient()

  const useNoticeProcurementOfficer = useAction({
    mutationFn: service.noticeProcurementOfficer,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Notice Procurement Officer',
  })

  const useApplySingleSource = useAction({
    mutationFn: service.applySingleSource,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Apply Single Source',
  })

  const useSendRFQ = useAction({
    mutationFn: service.sendRFQ,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Post RFQ',
  })

  const useSubmitTenderDocumentToProcurement = useAction({
    mutationFn: service.submitTenderDocumentToProcurement,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Submit Tender Document to Procurement',
  })
  const useInactiveTenderDocument = useAction({
    mutationFn: service.inactiveTenderDocument,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Inactive Tender Document',
  })
  const useActivateTenderDocument = useAction({
    mutationFn: service.activateTenderDocument,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Activate Tender Document',
  })

  const useToggleActiveOfferCostBudget = useAction({
    mutationFn: service.toggleActiveOfferCostBudget,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Toggle Cost budget active',
  })

  const useStartCostBudgetIssue = useAction({
    mutationFn: service.startCostBudgetIssue,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Create Cost Budget Workflow Issue',
  })

  const useReplyCostBudgetIssue = useAction({
    mutationFn: service.replyCostBudgetIssue,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Reply to Cost Budget Workflow Issue',
  })

  const useCompleteCostBudgetIssue = useAction({
    mutationFn: service.completeCostBudgetIssue,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Complete Cost Budget Workflow Issue',
  })

  const useInternalUploadCostBudgetQuotation = useAction({
    mutationFn: service.internalUploadCostBudgetQuotation,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Internal Upload Quotation',
  })

  const useUpdateVendorHistory = useAction({
    mutationFn: service.updateVendorHistory,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Update Vendor History',
  })

  const useUpdateVendorHistoryByIndex = useAction({
    mutationFn: service.updateVendorHistoryByIndex,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Update Vendor History',
  })

  const useFetchVendorDetail = ({ costBudgetId, vendorIndex, enabled = true }) => {
    return useQuery({
      queryKey: [...baseCrud.queryKey.detail(costBudgetId), 'vendorDetail', vendorIndex],
      queryFn: () => service.getVendorDetail({ costBudgetId, vendorIndex }),
      enabled: enabled && !!costBudgetId && vendorIndex !== null,
    })
  }

  const useFetchVendorHistory = ({ costBudgetId, vendorIndex, historyIndex, offerId, enabled = true }) => {
    return useQuery({
      queryKey: [...baseCrud.queryKey.detail(costBudgetId), 'vendorHistory', vendorIndex, historyIndex, offerId],
      queryFn: () => service.getVendorHistory({ costBudgetId, vendorIndex, historyIndex, offerId }),
      enabled: enabled && !!costBudgetId && vendorIndex !== null && historyIndex !== null,
    })
  }

  return {
    useFetchAllOfferCostBudgets: baseCrud.useFetchAll,
    useFetchOfferCostBudget: baseCrud.useFetchOne,
    useCreateOfferCostBudget: baseCrud.useCreate,
    useUpdateOfferCostBudget: baseCrud.useUpdate,
    useRemoveOfferCostBudget: baseCrud.useRemove,
    useNoticeProcurementOfficer,
    useSendRFQ,
    useApplySingleSource,
    useSubmitTenderDocumentToProcurement,
    useInactiveTenderDocument,
    useActivateTenderDocument,
    useToggleActiveOfferCostBudget,
    useStartCostBudgetIssue,
    useReplyCostBudgetIssue,
    useCompleteCostBudgetIssue,
    useInternalUploadCostBudgetQuotation,
    useUpdateVendorHistory,
    useUpdateVendorHistoryByIndex,
    useFetchVendorDetail,
    useFetchVendorHistory,
  }
}
